import { makeStyles } from '@material-ui/core/styles';

export const styles = makeStyles(theme => ({
  paragraph: {    
    marginTop: '0.25rem',
    fontSize: '80%',
    color: '#da4b48',
    }  
}))